import { Component, Input, OnInit } from '@angular/core';
import { TitleCardModel } from '../../../models/title-card.model';

@Component({
  selector: 'app-title-card',
  templateUrl: './title-card.component.html',
  styleUrl: './title-card.component.scss',
  standalone: false,
})
export class TitleCardComponent implements OnInit {
  @Input() titleCard: TitleCardModel;

  public ngOnInit() {
    if (this.titleCard === undefined) {
      this.titleCard = {
        title: 'Placeholder Title',
        descriptionBold: 'Placeholder Description Bold',
        description: 'Placeholder Description',
        image: null,
      };
    }
  }
}
